import { render, staticRenderFns } from "./FiltroData.vue?vue&type=template&id=5865bf12"
import script from "./FiltroData.vue?vue&type=script&lang=js"
export * from "./FiltroData.vue?vue&type=script&lang=js"
import style0 from "./FiltroData.vue?vue&type=style&index=0&id=5865bf12&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports